import React from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import MultiSelectDropdown from "../../../../../components/multiSelectDropdown/multiSelectDropdown";
import { actionCreators } from "../redux/noVisitAfterFirstVisitSagas";

const CustomFilters = () => {
  const dispatch = useDispatch();

  const { filters, category } = useSelector((state) => {
    let {
      filters,
      selectedFilters: { category }
    } = state.noVisitAfterFirstVisit;
    return { filters, category };
  }, shallowEqual);

  const onSelectChange = (data) => {
    dispatch(actionCreators.updateFilters(data));
  };

  return (
    <div className="select-box-no-width">
      <p>Revenue Categories</p>
      <MultiSelectDropdown
        options={filters}
        selectedFilters={category}
        height={400}
        allSelectedPlaceholder="All selected"
        numberDisplayed={0}
        includeSelectAll
        enableOnly
        onSelectChange={onSelectChange}
      />
    </div>
  );
};

export default CustomFilters;
